import { z } from 'zod';
import { postingStatusSchema } from './inventory.contract.js';
import { fuelMoneySchema } from './primitives.js';
/** Receipt kinds printed on the 80 mm roll (fuel.md section 9). */
export const receiptKindSchema = z.enum([
    'CASH_SALE',
    'DEBT_SALE',
    'PURCHASE',
    'PAYMENT',
    'RECEIPT',
    'DEBT_REPAYMENT',
]);
/** Everything the front end needs to print a receipt; labels come from i18n. */
export const receiptSchema = z.object({
    kind: receiptKindSchema,
    reference: z.string(),
    /** Real time of the entry, ISO-8601 with offset; shown in Asia/Amman. */
    occurredAt: z.iso.datetime({ offset: true }),
    lines: z.array(z.object({ categoryName: z.string(), qty: z.number().int(), value: fuelMoneySchema })),
    /** «إلا جركل»: the deducted jerrycans and their (negative) value, null when zero. */
    lessJerrycans: fuelMoneySchema.nullable(),
    lessJerrycansValue: fuelMoneySchema.nullable(),
    total: fuelMoneySchema,
    vehiclePlate: z.string().nullable(),
    debtorName: z.string().nullable(),
    personName: z.string().nullable(),
    statement: z.string().nullable(),
    /** Cash and debt sales print a QR code of the reference (fuel.md section 9). */
    qrValue: z.string().nullable(),
    /** A PDA purchase not yet priced: print «بانتظار التسعير» instead of prices and amounts. */
    pricePending: z.boolean().optional(),
});
/** Response of every operator create endpoint (the opening balance has no receipt). */
export const operationResultSchema = z.object({
    id: z.string(),
    reference: z.string(),
    receipt: receiptSchema.nullable(),
    /** PENDING when saved while وضع الجرد is on (fuel.md section 4.4). */
    postingStatus: postingStatusSchema,
});
//# sourceMappingURL=receipt.contract.js.map